export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11908.3d9bcecd.jpg";